import { FC } from "react";

interface ChevronDownProps {
  color?: string;
}

const ChevronDown: FC<ChevronDownProps> = ({ color = '#000' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 6" fill="none">
    <path fill={color} stroke={color} strokeWidth="0.2" d="M0.519531 1.52441C0.333311 1.2431 0.365028 0.860215 0.612305 0.612305L0.725586 0.519531C0.9666 0.359958 1.28207 0.360188 1.52344 0.519531L1.6377 0.612305L4.87402 3.85059L8.11133 0.613281V0.612305C8.35897 0.364031 8.74198 0.333868 9.02344 0.519531L9.13672 0.612305C9.38483 0.85978 9.41541 1.2419 9.22949 1.52344L9.13672 1.6377L5.38672 5.3877H5.3877C5.10492 5.6712 4.64569 5.67082 4.3623 5.3877L0.612305 1.6377L0.519531 1.52441Z" />
  </svg>
);

export default ChevronDown;